import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';


@Injectable()
export class DwIamHttpErrorHandler {

  constructor(private route: Router) {

  }

  handlerError(error: HttpErrorResponse): void {
    if (error.status === 401) {
      // 缺少必要的token，無法繼續操作
      // UserToken逾時，建議更新UserToken或重新登入
      this.route.navigate(['/login']);

    } else if (error.status === 406) {
      // UserToken異常，建議重新登入
      this.route.navigate(['/login']);

    } else if (error.status === 500) {
      // 服務端系統錯誤，更多資訊請查詢系統記錄

    } else if (error.status === 503) {
      // 外部連接服務異常，可能是無法連線到後端資料庫
    }
  }
}
